import { FC, ReactNode, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAppSelector } from '../../redux'
import { ROUTES } from '../../utils'
import { StyledState } from '.'

type Props = {
  children: ReactNode
}

const State: FC<Props> = ({ children }) => {
  const history = useHistory()
  const { _id } = useAppSelector((state) => state.user)

  useEffect(() => {
    if (!_id) {
      return history.push(ROUTES.auth.login)
    }
  }, [_id, history])

  return (
    <StyledState>
      {children}
    </StyledState>
  )
}

export default State
